<!-- 保险信息 模块  订单填写 订单详情中 -->
<template>
  <van-cell v-show="bxcpList.length > 0">
    <van-checkbox-group
      class="InsuranceGroup"
      v-model="bxList"
      icon-size="16"
    >
      <van-checkbox
        v-for="(info, index) in bxcpList"
        :key="index"
        :name="info"
        :disabled="info.disabled"
        :style="{ marginTop: index > 0 ? '10px': '' }"
      >
        <i
          v-if="hideCheckBox"
          slot="icon"
        />
        <van-row
          type="flex"
          align="center"
          :style="{ marginLeft: hideCheckBox ? 0 : '8px' }"
        >
          <van-col
            span="14"
            :class="[(info.qzbd === '2'||info.disabled)? 'gray' : 'black']"
          >
            <h4 class="bxmcTitle">
              {{ info.bxmcTitle }}
            </h4>
            <p
              v-for="label in info.bxmcLabels"
              class="fong10 gray"
              :key="label"
            />
          </van-col>
          <van-col span="2">
            <van-tag
              v-if="info.qzbd === '2'"
              type="danger"
              plain
            >
              赠
            </van-tag>
          </van-col>
          <van-col
            span="2"
            @click.stop="popupDetail(info)"
          >
            <van-icon
              class="main-color sub"
              name="info"
              size="18"
            />
          </van-col>
          <van-col
            span="6"
            class="text-right"
            @click.stop="popupDetail(info)"
          >
            <span class="font16 red"><small>&yen;</small> {{ info.saleprice||info.salePrice||0 }}</span>
            <span class="gray"> *{{ cxrlength }} {{ $t('E501','份') }}</span>
          </van-col>
        </van-row>
      </van-checkbox>
    </van-checkbox-group>

    <insurance-detail
      :value="insuranceDetail"
      :visibility.sync="popupShow"
      :element="element"
    />
  </van-cell>
</template>

<script>
import { Cell, Checkbox, CheckboxGroup, Tag } from 'vant'
import insuranceDetail from './InsuranceDetail'

import InsuranceInteractor from 'Domain/use-cases/insurance-interactor'


export default {
  name: 'Insurance',
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [insuranceDetail.name]: insuranceDetail,
  },
  props: {
    cplx: {
      type: [String, Number],
      default: '10901'
    },
    cxrlength: {
      type: [String, Number],
      default: 0
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    checkBxList: {
      type: Array,
      default: () => []
    },
    element:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bxcpList: [],//保险列表
      hideCheckBox: false,//订单详情 只展示 禁止选择
      popupShow: false,
      insuranceDetail: {},//保险详情
      bxList:[]
    }
  },
  created() {
    this.init()
    console.log('保险',this)
  },
  methods: {
    init () {
      this.bxcpList = []
      this.bxList = []

      if (this.orderId) {
        this.hideCheckBox = true
        this.getBx()
      } else if (this.cplx) {
        this.getList()
      }
    },
    async getBx() {
      const { bxcpList } = await InsuranceInteractor.getInsuranceOrderById(this.orderId)
      this.bxcpList = bxcpList
      this.bxList = bxcpList
    },
    async getList() {
      const { data } = await InsuranceInteractor.getProductList(this.cplx)

      this.bxcpList = data

      this.bxList = this.bxcpList.filter(bxcp => {
        if (bxcp.qzbd === '1' || bxcp.qzbd === '2') {
          bxcp.disabled = true
          return bxcp
        } else if (bxcp.qzbd === '3') {
          return bxcp
        }
      })
    },
    // 选中保险
    getInsurance() {
      let arr = []
      this.bxList.forEach(item => {
        arr.push({
          bxid: item.bxid,
          bxmc: item.bxmc,
          bxxz: item.bxxz,
          bxxzmc: item.bxxzmc,
          saleprice: item.saleprice,
          sxgz: item.sxgz,
          cpsm: item.cpsm
        })
      })
      return arr
    },
    popupDetail(detail) {
      this.insuranceDetail = detail
      this.popupShow = true
    }
  },
  watch: {
    checkBxList: {
      handler (val) {
        this.bxList=val
      },
      deep: true,
      immediate: true
    },
    bxList: {
      handler (val) {
        this.$emit('update:checkBxList', val)
        this.$emit('selected', val)
      },
      deep: true,
      immediate: true
    },
    cplx(){
      this.init()
    },
    orderId(){
      this.init()
    }
  }
}
</script>

<style lang="less">
.InsuranceGroup {
  .van-checkbox {
    align-items: inherit;

    .van-checkbox__icon {
      margin-top: 2px;
    }

    .van-checkbox__label {
      width: 100%;
      margin-left: 0;
    }
  }

  .bxmcTitle {
    margin: 0;
  }
  .sub{
    vertical-align: sub;
  }
}
</style>
